import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { IHourTransaction } from '../interface/transaction';

// A fresh [] per render would re-trigger every effect that depends on the result while loading.
const NO_HOUR_TRANSACTIONS: IHourTransaction[] = [];

export const useFetchMyLastSevenDaysHourTransactions = (currentWeek = false) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['seven-days-hour-transactions', { currentWeek }],
    queryFn: () => {
      return get(API_URLS.LAST_SEVEN_DAYS_HOUR_TRANSACTION, currentWeek ? { currentWeek } : {});
    },
  });

  return {
    data: error ? NO_HOUR_TRANSACTIONS : (data?.data ?? NO_HOUR_TRANSACTIONS),
    isLoading,
    error,
    refetch,
  };
};
